import { render, staticRenderFns } from "./Dashboard_3.vue?vue&type=template&id=2d6f0aef&"
import script from "./Dashboard_3.vue?vue&type=script&lang=js&"
export * from "./Dashboard_3.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports